(function () {
    if (window.mdPostMetricsInitialized) return;
    window.mdPostMetricsInitialized = true;
    const initialized = new WeakSet();
    const pending = new Map();
    let batchTimer;
    const readSummary = function (id) {
        return new Promise(function (resolve, reject) {
            if (!pending.has(id)) pending.set(id, []);
            pending.get(id).push({resolve: resolve, reject: reject});
            clearTimeout(batchTimer);
            batchTimer = setTimeout(async function () {
                const batch = new Map(pending);
                pending.clear();
                const ids = Array.from(batch.keys());
                for (let offset = 0; offset < ids.length; offset += 100) {
                    const chunk = ids.slice(offset, offset + 100);
                    try {
                        const response = await fetch('/api/metrics/posts?ids=' + encodeURIComponent(chunk.join(',')), {
                            credentials: 'same-origin',
                            headers: {Accept: 'application/json'},
                            signal: AbortSignal.timeout(10000),
                        });
                        if (!response.ok) throw new Error('Batch metrics unavailable');
                        const data = await response.json();
                        chunk.forEach(function (postId) {
                            const row = data.posts.find(function (post) { return post.ghost_post_id === postId; });
                            batch.get(postId).forEach(function (job) {
                                if (row) job.resolve(row);
                                else job.reject(new Error('Missing metrics'));
                            });
                        });
                    } catch (error) {
                        chunk.forEach(function (postId) {
                            batch.get(postId).forEach(function (job) { job.reject(error); });
                        });
                    }
                }
            }, 30);
        });
    };
    const pause = function (ms) {
        return new Promise(function (resolve) { setTimeout(resolve, ms); });
    };
    const initialize = function () {
    const groups = new Map();
    const roots = document.querySelectorAll('[data-post-metrics]');

    roots.forEach(function (root) {
        if (initialized.has(root)) return;
        initialized.add(root);
        const postId = root.dataset.postMetrics;
        if (!postId) return;

        let group = groups.get(postId);
        if (!group) {
            group = {
                interactive: false,
                postId: postId,
                roots: [],
            };
            groups.set(postId, group);
        }

        group.roots.push(root);
        group.interactive =
            group.interactive ||
            (root.dataset.metricsMode || 'interactive') === 'interactive';
    });

    if (!groups.size) return;

    const request = async function (path, method) {
        for (let attempt = 0; attempt < 4; attempt += 1) {
        try {
        const response = await fetch(path, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            method: method || 'GET',
        });
        if (response.status === 429 && attempt < 3) {
            const retryAfter = Number(response.headers.get('Retry-After'));
            await pause(Math.max(61000, (retryAfter || 0) * 1000));
            continue;
        }
        if (!response.ok) throw new Error('metrics request failed');
        return response.json();
        } catch (error) {
            if (attempt === 3) throw error;
            await pause(1000 * Math.pow(2, attempt));
        }
        }
    };

    groups.forEach(function (group) {
        const endpoint =
            '/api/metrics/posts/' + encodeURIComponent(group.postId);
        let loadPromise;

        const render = function (metrics) {
            group.roots.forEach(function (root) {
                const likeButton = root.querySelector('[data-metric-like]');
                const likeCount = root.querySelector('[data-metric-likes]');
                const viewCount = root.querySelector('[data-metric-views]');
                const heart = root.querySelector('[data-metric-heart]');

                if (likeCount)
                    likeCount.textContent = Number(
                        metrics.likes || 0,
                    ).toLocaleString('ko-KR');
                if (viewCount)
                    viewCount.textContent = Number(
                        metrics.views || 0,
                    ).toLocaleString('ko-KR');
                if (heart) heart.textContent = metrics.liked ? '♥' : '♡';
                if (likeButton) {
                    likeButton.setAttribute(
                        'aria-pressed',
                        metrics.liked ? 'true' : 'false',
                    );
                    likeButton.classList.toggle(
                        'is-liked',
                        Boolean(metrics.liked),
                    );
                }
            });
        };

        const loadMetrics = function () {
            if (!loadPromise) {
                const path = group.interactive ? endpoint + '/view' : endpoint;
                const method = group.interactive ? 'POST' : 'GET';
                loadPromise = (group.interactive ? request(path, method) : readSummary(group.postId))
                    .catch(function () {
                        return group.interactive ? request(endpoint) : pause(2000).then(function () { return readSummary(group.postId); });
                    })
                    .then(function (metrics) {
                        render(metrics);
                        return metrics;
                    })
                    .catch(function () {
                        group.roots.forEach(function (root) {
                            const count = root.querySelector('[data-metric-views]');
                            if (count) count.textContent = '일시 오류';
                        });
                        loadPromise = null;
                        return null;
                    });
            }
            return loadPromise;
        };

        group.roots.forEach(function (root) {
            const likeButton = root.querySelector('[data-metric-like]');
            if (!likeButton) return;

            likeButton.addEventListener('click', async function () {
                if (
                    likeButton.disabled ||
                    likeButton.classList.contains('is-liked')
                )
                    return;
                likeButton.disabled = true;
                try {
                    await loadMetrics();
                    render(await request(endpoint + '/like', 'POST'));
                } catch (error) {
                    // Keep the button available for a later retry without showing a blocking message.
                } finally {
                    likeButton.disabled = false;
                }
            });
        });

        loadMetrics();
    });
    };
    initialize();
    // Infinite pagination inserts cards after the initial document load.
    // Watch only added elements; text updates must not trigger another request.
    new MutationObserver(function (records) {
        if (records.some(function (record) {
            return Array.from(record.addedNodes).some(function (node) {
                return node.nodeType === 1 &&
                    (node.matches('[data-post-metrics]') || node.querySelector('[data-post-metrics]'));
            });
        })) initialize();
    }).observe(document.body, { childList: true, subtree: true });
})();
